module.exports = __webpack_public_path__ + "static/media/passkey.2d2343a4.svg";